export const UPLOAD_SELECTION_MODE = 'UploadSelection';

export const LOCAL_FILE_UPLOAD_MODE = 'LocalFileUpload';

export const STOCK_IMAGE_UPLOAD_MODE = 'StockImage';

export const FILE_LIST_MODE = 'FileList';

export const EDIT_FILE_MODE = 'EditFile';
